import React from 'react';
import PropTypes from 'prop-types';

import {
  StatusRow,
  CommentsRow,
  InternalReferenceRow,
  AddressRow,
  ContactRow,
  CargoManifestRow,
} from './rows';

import AggregatedLoadRow from 'modules/stop-card/AggregatedLoadRow';
import LoadsRow from 'modules/stop-card/LoadsRow';
import HeaderRow from 'modules/stop-card/HeaderRow';
import TimesRow from 'modules/stop-card/TimesRow';

import { StyledCard } from './styled';
import PincodeRow from './rows/PincodeRow';

const StopCard = (props) => {
  const { stop } = props;
  const hasPincode = !!stop.pincode;

  if (stop?.isAggregated) {
    return (
      <StyledCard>
        <HeaderRow {...props} /> {/** LOCATOR GOES HERE */}
        <StatusRow {...props} />
        <AggregatedLoadRow {...props} /> {/** CONTAINER; REFERENCE; LLENO/VACIO */}
        <TimesRow {...props} />
        {!!stop?.store && <CommentsRow {...props} />}
        <AddressRow {...props} />
        {!!stop?.store && <ContactRow {...props} />}
        <CargoManifestRow {...props} />
        {hasPincode && <PincodeRow pincode={stop.pincode} />}
      </StyledCard>
    );
  }

  return (
    <StyledCard>
      <HeaderRow {...props} />
      <StatusRow {...props} />
      <LoadsRow {...props} />
      <TimesRow {...props} />
      <CommentsRow {...props} />
      <AddressRow {...props} />
      <ContactRow {...props} />
      <InternalReferenceRow {...props} />
      <CargoManifestRow {...props} />
      {hasPincode && <PincodeRow pincode={stop.pincode} />}
    </StyledCard>
  );
};

StopCard.propTypes = {
  stop: PropTypes.object,
  stops: PropTypes.array,
  renderChild: PropTypes.number,
  onUploadClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  stopId: PropTypes.number,
  shipperOrdersSkin: PropTypes.object,
};

StopCard.defaultProps = {
  stop: {},
  stops: [],
  renderChild: 0,
  shipperOrdersSkin: {},
};

export default StopCard;
